import { Download } from 'lucide-react';

import React from 'react';

import { CSV_GUIDE, importExamplePath } from '@splitfiesta/core';
import { useTranslation } from '@splitfiesta/i18n';

import { ImportOption } from './ImportOption';
import { InstructionSteps } from './InstructionSteps';

/** The steps for a hand-built CSV, plus the example file in the UI language. */
export function CsvGuide() {
  const { t, i18n } = useTranslation();
  return (
    <ImportOption title={t(CSV_GUIDE.titleKey)} data-testid="import-csv-guide">
      <InstructionSteps
        steps={CSV_GUIDE.ruleKeys.map(key => t(key))}
        footer={
          <a
            href={importExamplePath(i18n.language)}
            download
            data-testid="import-csv-example"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300"
          >
            <Download className="h-4 w-4" aria-hidden="true" />
            {t(CSV_GUIDE.downloadKey)}
          </a>
        }
      />
    </ImportOption>
  );
}
